// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Results_wrapper__DMgaX","fade":"Results_fade__UD4aZ","showHighlight":"Results_showHighlight__6kMb6"};